import React, {Component} from "react"
import PropTypes from "prop-types"
import {FormattedMessage} from "@irati/utils/lang"
import Validation from "@irati/utils/validation"
import PopUpWithImage from "@irati/ui/src/PopUpWithImage"
import Button from "@irati/ui/src/Button"

class SelfSignUpPopup extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      show: null
    }
  }

  open = (show) => {
    this.setState({show})
    this.popup.open()
  }

  handleCancel = () => {
    this.props.onChange(this.state.show)
    this.popup.close()
  }

  handleSave = () => {
    Validation.validate().then(() => {
      this.props.onChange(this.state.show, true)
      this.popup.close()
    }).catch(() => this.popup.close())
  }

  render() {
    return (
      <PopUpWithImage
        ref={(c) => { this.popup = c }}>
        <p className="center push--bottom">
          <FormattedMessage id="admin.components.selfSignUpPopup.text" />
        </p>
        <Button className="pull-left" onClick={this.handleCancel}>
          <FormattedMessage id="admin.components.selfSignUpPopup.button.discard" />
        </Button>
        <Button primary className="pull-right" onClick={this.handleSave}>
          <FormattedMessage id="admin.components.selfSignUpPopup.button.save" />
        </Button>
      </PopUpWithImage>
    )
  }
}

export default SelfSignUpPopup
